import React from "react";
import EnhancedContentSection from "./../../components/common/enhanced-content-section";
import ButtonFx from "./../../components/common/button-fx";
import PageTagging from "components/common/page-tagging/page-tagging";
import "./about.scss";

const About = () => {
  const podcastUrl = "https://www.therentaljournal.com/chattingwithjamiehaitas";

  const openPodcast = () => {
    window.open(podcastUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <PageTagging
        title="About Us | Specialised Traffic Equipment Hire Melbourne"
        description="Mr Traffic Hire offers specialised traffic equipment hire on any scale, such as large infrastructure road works and projects to single Variable Messaging Signs for advertising."
      />

      <section className="about-hero">
        <div className="about-hero-inner">
          <div className="about-hero-content">
            <span className="about-eyebrow">About Us</span>

            <h1>
              Specialised traffic equipment hire backed by{" "}
              <span>industry experience</span>
            </h1>

            <p>
              Mr Traffic Hire offers specialised traffic equipment hire on any
              scale, such as large infrastructure road works and projects to
              single Variable Messaging Signs (VMS) for advertising. We have a
              full range of traffic safety equipment.
            </p>
          </div>

          <div className="about-hero-image">
            <img src="/images/gp-image.jpg" alt="Melbourne GP Arrowboard" />
          </div>
        </div>
      </section>

      <EnhancedContentSection isBlocking={false} showPageTitle={false}>
        <section className="about-overview">
          <div className="about-overview-content">
            <span className="about-eyebrow">Industry Knowledge</span>

            <h2>Over 25 years combined experience</h2>

            <p>
              With over 25 years combined experience in the Hire industry Mr
              Traffic Hire can offer our clients the most up to date solutions
              for managing your needs, combined with our vast industry
              knowledge, makes us confident that we can provide solutions to our
              clients.
            </p>

            <p>
              At Mr Traffic Hire we endeavour to work closely with all our
              clients to find a solution that works and with our expert
              knowledge and understanding of current legislation, in addition to
              providing the highest level of quality, service and value, Mr
              Traffic Hire is confident we can help you achieve your targets.
            </p>
          </div>

          <aside className="about-availability">
            <div className="about-availability-icon">
              <i className="far fa-clock"></i>
            </div>

            <div className="about-availability-content">
              <span>Always Available</span>

              <h3>24 Hours a Day, 7 Days a Week</h3>

              <p>
                Mr Traffic Hire is available 24 hours a day, 7 days a week and
                we will work within your timeframes and budget to make it
                happen.
              </p>
            </div>
          </aside>
        </section>

        <section className="about-team">
          <div className="about-section-heading">
            <span className="about-eyebrow">Meet Our Team</span>
            <h2>Our Team</h2>
          </div>

          <article className="about-team-card">
            <div className="about-team-content">
              <div className="about-team-title">
                <h3>Jamie Haitas</h3>
                <strong>General Manager</strong>
              </div>

              <p>
                Jamie has over 15 years’ experience in the traffic hire
                industry. Jamie commenced with Kennards Traffic in 2010.
              </p>

              <p>
                Whilst at Kennards Jamie expanded the hire fleet from 20 VMS to
                150, acquired a fleet of over 2000 barriers, built the first
                hire TMA in Australia and grew this to a fleet of 70 Australia
                wide. During this period Jamie also expanded the business from
                $4 million to $20 million turnover.
              </p>

              <p>
                In 2014 Jamie was approached by RSEA to help grow the business.
                Jamie relocated RSEA to a more suitable premises and expanded
                the VMS fleet from 40 to 100. Jamie successfully procured the
                first Zoneguard steel barrier job on the Tullamarine Freeway
                upgrade, supplied and installed 10.5kms of steel barrier over 3
                months and had in out for 2.5 years.
              </p>

              <p>
                In 2017 Jamie was approached by J1LED to build their Victorian
                business. Jamie sold 40 TMA’s into the Melbourne market. Whilst
                working for J1LED it became evident that with Jamie’s experience
                and expertise he should establish and commence his own hire
                business.
              </p>

              <p>
                In October 2017 Jamie formed Mr Traffic Hire Pty Ltd servicing
                the Traffic Management Industry with specialised traffic
                equipment and the company continues to grow.
              </p>
            </div>

            <aside className="about-team-profile">
              <div className="about-team-image">
                <img
                  src="/images/jamie.jpg"
                  alt="Jamie Haitas, General Manager"
                  loading="lazy"
                />
              </div>

              <a
                href="https://www.linkedin.com/in/jamie-haitas-98113357/"
                target="_blank"
                rel="noopener noreferrer"
                className="about-linkedin"
              >
                <i className="fab fa-linkedin-in"></i>
                <span>View LinkedIn Profile</span>
              </a>
            </aside>
          </article>
        </section>
      </EnhancedContentSection>

      <section className="about-podcast">
        <div className="about-podcast-inner">
          <a
            href={podcastUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="about-podcast-image"
            aria-label="Listen to Jamie Haitas on The Rental Journal podcast"
          >
            <img
              src="/images/podcast.jpg"
              alt="Jamie's Podcast"
              loading="lazy"
            />
          </a>

          <div className="about-podcast-content">
            <span className="about-podcast-eyebrow">
              The Rental Journal Podcast
            </span>

            <h2>
              Jamie&apos;s <span>Podcast</span>
            </h2>

            <p className="about-podcast-quote">
              &ldquo;The ups and downs of my hire journey over the last 13
              years&rdquo;
            </p>

            <p>
              Jamie opens up about some of the struggles he went through early
              in his career from over working and putting too much pressure on
              himself.
            </p>

            <p>
              Check out this link to hear Jamie talking about his path to Mr
              Traffic Hire.
            </p>

            <ButtonFx
              className="mt-aqua-mini-button about-podcast-button"
              onClick={openPodcast}
            >
              <i className="fas fa-headphones mr-2"></i>
              Listen Now
            </ButtonFx>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;